module.exports = __webpack_public_path__ + "media/images/logo-magnet-5bc77dd2.svg";